import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ReportsApiService {
  private http = inject(HttpClient);

  public reportExecution(data: any): Observable<any> {
    return this.http.post(`${environment.api}/report/data`, data);
  }
}
